import { render, staticRenderFns } from "./business-investments.vue?vue&type=template&id=ce0be3d4&"
import script from "./business-investments.vue?vue&type=script&lang=ts&"
export * from "./business-investments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports